import React from "react";
import { TriangleAlert } from "lucide-react";

const VERIFIED_NUMBERS_URL =
  "https://console.twilio.com/us1/develop/phone-numbers/manage/verified";
const TRIAL_BLOG_URL =
  "https://www.twilanswer.com/blog/twilio-trial-account-limitations";

const linkClass =
  "underline font-medium text-[#854D0F] hover:text-[#713F12]";

/**
 * Informational banner shown when the org's Twilio account is on a trial.
 */
const TwilioTrialBanner = ({ className = "" }) => {
  return (
    <div
      className={`border-[1px] border-[#FFEF8A] text-[#854D0F] bg-[#FEFCE8] px-6 py-2 ${className}`}
    >
      <div className="flex items-center text-[14px] font-bold text-[#854D0F]">
        <TriangleAlert className="text-[#FACB14] w-[16px] mr-2 shrink-0" />
        Twilio Trial Account Detected
      </div>
      <div className="text-[#854D0F] text-[14px] my-2 ml-6">
        Your Twilio account is on a trial. You are only able to call{" "}
        <a
          href={VERIFIED_NUMBERS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={linkClass}
        >
          verified numbers
        </a>
        .
      </div>
      <div className="text-[13px] ml-6 mb-1">
        <a
          href={TRIAL_BLOG_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={linkClass}
        >
          Learn more about Twilio trial limitations
        </a>
      </div>
    </div>
  );
};

export default TwilioTrialBanner;
